module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"positions":"Positionen","noPositionsAvailable":"Keine Positionen vorhanden"},"en":{"positions":"Positions","noPositionsAvailable":"No Positions available"}}')
  delete Component.options._Ctor
}
